// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"ArchiveModalBox_contentContainer_2-p4M","spinAround":"ArchiveModalBox_spinAround_10aZZ"};